import { get, put } from './apiClient';
import { ApiResponse } from './tenantApi';

// Type definitions for the database settings
export interface DatabaseSettings {
  Servers: {
    Host: string;
    Port: number;
  }[];
  UserName: string;
  SecretStoreName: string;
  SecretKey: string;
  UseTls: boolean;
  Scheme: string;
  DatabaseName: string;
  AuthenticationMechanism: string;
  AuthenticationSource: string;
  TenantsCollectionName: string;
  ClustersCollectionName: string;
}

/**
 * Get database settings
 * @returns Promise with settings
 */
export const getSettings = (): Promise<ApiResponse<DatabaseSettings>> => {
  return get<ApiResponse<DatabaseSettings>>('/settings');
};

/**
 * Update database settings
 * @param settings Settings to update
 * @returns Promise with updated settings
 */
export const updateSettings = (settings: DatabaseSettings): Promise<ApiResponse<DatabaseSettings>> => {
  return put<ApiResponse<DatabaseSettings>>('/settings', settings);
};